import { getNoAuthShortUrl, hasNoAuth } from "@/lib/noauth"
import { requestApi } from "@/lib/request"
import { requestJson } from "../lib/request";
import { commonParams } from "@/config/common";

/** 
 * 数据集市页面
 */
class DataMarket {
    static base_url = `${ commonParams.PAAS_CONFIG }/config/`

    static getAllianceConfig(){
        return requestJson(`${this.base_url}alliance_conf.json`)
    }

    // 获取数据集市问卷列表
    static getDataMarket(size,i) {
        return requestApi(`/datamark/tenant/answer/list?sortWay=desc&columnName=create_time&currPageSize=${size}&currPageIndex=${i}`, 
        'get', {}, {}, true)
    }

    // 作答中心-credamo数据集市列表
    static getDataCredamo(size,i) {
        return requestApi(`/datamark/noauth/credamo/answer/list?sortWay=desc&columnName=create_time&currPageSize=${size}&currPageIndex=${i}`, 
        'get', {}, {}, true)
    }

    // 获取作答记录
    static getAnswerRecords(i) {
        return requestApi(`/survey/answer/answerRecords?currPageSize=10&currPageIndex=${i}`, 'get', {}, {}, true)
    }

    // 获取GMO问卷列表
    static getGMO() {
        return requestApi('/datamark/noauth/third/survey/list', 'get', {}, {})
    }

    static getForwardUrlShortUrl(shortUrl){
        let url = '/dispense/getForwardQrUrl/shortUrl/' + shortUrl
        if(hasNoAuth(shortUrl)){
            shortUrl = getNoAuthShortUrl(shortUrl)
            url= '/dispense/noauth/getForwardQrUrl/shortUrl/' + shortUrl
        }
        return requestApi(url, 'get', {}, {}, true)
    }
}

export {
    DataMarket
}


// WEBPACK FOOTER //
// ./src/models/data-market.js